import React from 'react';
import { FaBullseye, FaUser, FaRobot, FaCog, FaEdit } from 'react-icons/fa';
import UserCardHeader from './UserCardHeader';
import UserDetails from './UserDetails';
import '../../styles/Home.css';

export default function TwitchUserCard({
  user,
  onGoToDashboard,
  onNavigateProfile,
  onEdit,
  isAppCard = false,
  appData = null,
  twitchUser = null,
}) {
  if (!user) {
    return null;
  }

  let details;

  if (isAppCard && appData) {
    // Affichage pour les cartes d'application Twitch
    if (appData.isSystemApp) {
      // App système (tokens existants) - afficher les infos utilisateur
      const twitchInfo = appData.twitchUser || twitchUser;
      details = [
        { label: 'Pseudo', value: twitchInfo?.login || 'Non disponible' },
        {
          label: "Nom d'affichage",
          value: twitchInfo?.display_name || 'Non disponible',
        },
        {
          label: 'Statut',
          value: 'Connecté (Application système)',
        },
        {
          label: 'Dernière connexion',
          value: new Date(appData.updatedAt).toLocaleDateString('fr-FR', {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
          }),
        },
      ];
      // Utiliser les informations Twitch pour l'avatar et le nom
      if (twitchInfo) {
        user = {
          ...user,
          display_name: twitchInfo.display_name,
          profile_image_url: twitchInfo.profile_image_url,
        };
      }
    } else {
      // App personnalisée
      details = [
        { label: "Nom de l'app", value: appData.appName },
        {
          label: 'Client ID',
          value: `${appData.clientId.substring(0, 12)}...`,
        },
        {
          label: 'Statut',
          value: appData.isActive ? 'Activée' : 'Désactivée',
        },
        {
          label: 'Créée le',
          value: new Date(appData.createdAt).toLocaleDateString('fr-FR', {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
          }),
        },
      ];
    }
  } else {
    // Affichage normal pour les cartes utilisateur Twitch
    details = [
      { label: 'Pseudo', value: user.login },
      { label: 'ID', value: user.id },
      ...(user.description
        ? [
            {
              label: 'Description',
              value:
                user.description.length > 50
                  ? `${user.description.substring(0, 50)}...`
                  : user.description,
            },
          ]
        : []),
      {
        label: 'Compte créé',
        value: new Date(user.created_at).toLocaleDateString('fr-FR', {
          year: 'numeric',
          month: 'short',
          day: 'numeric',
        }),
      },
    ];
  }

  return (
    <div className="card fade-in user-card">
      <UserCardHeader
        user={user}
        platform={isAppCard ? 'Application Twitch' : 'Twitch'}
        avatarUrl={isAppCard ? null : user.profile_image_url}
        avatarAlt={user.display_name}
        icon={isAppCard ? FaRobot : null}
      />
      <div className="section">
        <UserDetails details={details} />
        <div className="user-actions">
          {isAppCard ? (
            appData?.isSystemApp ? (
              // Actions pour les apps système
              <>
                <button
                  className="user-action-btn primary"
                  onClick={onGoToDashboard}
                >
                  <FaBullseye /> Dashboard
                </button>
                <button
                  className="user-action-btn secondary"
                  onClick={() => onNavigateProfile('twitch')}
                >
                  <FaUser /> Profil Twitch
                </button>
              </>
            ) : (
              // Actions pour les apps personnalisées
              <>
                {onEdit && (
                  <button
                    className="user-action-btn edit"
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      onEdit();
                    }}
                    title="Modifier l'application"
                  >
                    <FaEdit /> Modifier
                  </button>
                )}
                <button
                  className="user-action-btn primary"
                  onClick={onGoToDashboard}
                >
                  <FaBullseye /> Gérer l'app
                </button>
                <button
                  className="user-action-btn secondary"
                  onClick={() => onNavigateProfile('twitch-app')}
                >
                  <FaCog /> Configuration
                </button>
              </>
            )
          ) : (
            <>
              <button
                className="user-action-btn primary"
                onClick={onGoToDashboard}
              >
                <FaBullseye /> Dashboard
              </button>
              <button
                className="user-action-btn secondary"
                onClick={() => onNavigateProfile('twitch')}
              >
                <FaUser /> Profil
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
